// Единые параметры анимаций для Framer Motion
export const defaultTransition = {
  duration: 0.8,
  ease: [0.4, 1.4, 0.6, 1],
};

export const modalTransition = {
  duration: 0.3,
  ease: [0.4, 0, 0.2, 1],
  type: "tween",
};

export const overlayTransition = {
  duration: 0.2,
  ease: [0.4, 0, 0.2, 1],
  type: "tween",
};

export const burgerTransition = {
  duration: 0.4,
  ease: [0.25, 0.46, 0.45, 0.94],
  type: "tween",
}; 